(function(){
"use strict";

// ── STATE ────────────────────────────────────────────────────────────────────
var zoom=14, size=4, sizeMin=2, sizeMax=12, detail='med';
var arcSz=[0,8,24,8.5];
var mapLoaded=false, isLoading=false;
var map=null, pinMarker=null, pinEl=null;
var mapCenter=null, mapLabel='';
var geoRequestId=0;
var zoomValEl=document.getElementById('zoomVal')||{textContent:''};
var PV_W=300;

// ── HELPERS ──────────────────────────────────────────────────────────────────
function setStatus(cls,msg){var e=document.getElementById('mapStatus');e.className='map-status'+(cls?' '+cls:'');e.textContent=msg;}
function getUnit(){var e=document.querySelector('[data-group="unit"].on');return e?e.dataset.val:'in';}
function fmtZoom(z){return Number.isInteger(z)?String(z):z.toFixed(1);}
function updateDimHint(){
  var u=getUnit(),dh=document.getElementById('dimHint');
  if(dh) dh.textContent=(u==='in'?'\u2248 '+(size*25.4).toFixed(1)+' mm':'\u2248 '+(size/25.4).toFixed(2)+' in')+' export size';
  var sv=document.getElementById('sizeVal');
  if(sv){if(sv.tagName==='INPUT')sv.value=size;else sv.textContent=size;}
}
function xmlEsc(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function showLoading(on){var el=document.getElementById('mapLoading');if(el)el.style.display=on?'block':'none';}

// ── MAPLIBRE STYLE ───────────────────────────────────────────────────────────
var ORNAMENT_STYLE={
  version:8,
  sources:{openmaptiles:{type:'vector',url:'https://tiles.openfreemap.org/planet'}},
  layers:[
    {id:'background',type:'background',paint:{'background-color':'#d4c3a7'}},
    {id:'water',type:'fill',source:'openmaptiles','source-layer':'water',paint:{'fill-color':'#7ec8e3','fill-opacity':0.9}},
    {id:'road-motorway',type:'line',source:'openmaptiles','source-layer':'transportation',
     filter:['==',['get','class'],'motorway'],
     paint:{'line-color':'#000','line-width':['interpolate',['linear'],['zoom'],5,0.5,10,2,14,5,18,10],'line-opacity':1},
     layout:{'line-cap':'round','line-join':'round'}},
    {id:'road-primary',type:'line',source:'openmaptiles','source-layer':'transportation',
     filter:['match',['get','class'],['trunk','primary'],true,false],
     paint:{'line-color':'#000','line-width':['interpolate',['linear'],['zoom'],7,0.3,10,1.2,14,3.5,18,7],'line-opacity':1},
     layout:{'line-cap':'round','line-join':'round'}},
    {id:'road-secondary',type:'line',source:'openmaptiles','source-layer':'transportation',
     filter:['match',['get','class'],['secondary','tertiary'],true,false],
     paint:{'line-color':'#000','line-width':['interpolate',['linear'],['zoom'],9,0.2,12,1,14,2,18,4.5],'line-opacity':1},
     layout:{'line-cap':'round','line-join':'round'}},
    {id:'road-minor',type:'line',source:'openmaptiles','source-layer':'transportation',
     filter:['==',['get','class'],'minor'],
     paint:{'line-color':'#000','line-width':['interpolate',['linear'],['zoom'],12,0.3,14,1,18,2.5],'line-opacity':1},
     layout:{'line-cap':'round','line-join':'round','visibility':'visible'}},
    {id:'road-service',type:'line',source:'openmaptiles','source-layer':'transportation',
     filter:['match',['get','class'],['service','track','path'],true,false],
     paint:{'line-color':'#000','line-width':['interpolate',['linear'],['zoom'],13,0.2,15,0.6,18,1.5],'line-opacity':1},
     layout:{'line-cap':'round','line-join':'round','visibility':'none'}}
  ]
};

// ── MAPLIBRE INIT ────────────────────────────────────────────────────────────
function initMap(){
  if(map) return;
  map=new maplibregl.Map({
    container:'mapContainer',
    style:ORNAMENT_STYLE,
    center:[0,20],zoom:2,
    attributionControl:false,
    logoPosition:'bottom-left'
  });
  map.scrollZoom.setWheelZoomRate(1/200);
  map.on('zoomend',function(){
    zoom=Math.round(map.getZoom()*2)/2;
    zoom=Math.max(7,Math.min(19,zoom));
    document.getElementById('zoomSlider').value=zoom;
    zoomValEl.textContent=fmtZoom(zoom);
  });
  map.on('load',function(){ map.resize(); });
  map.on('style.load',function(){ setDetail(detail); });
  map.on('dataloading',function(){ showLoading(true); });
  map.on('idle',function(){ showLoading(false); });
  map.on('error',function(e){ console.warn('MapLibre error:',e.error); });
  window._appMap=map;
}

// ── PIN HELPERS ──────────────────────────────────────────────────────────────
// True "location point" (the tip that should sit exactly on the coordinate)
// for each icon, in its 24x24 viewBox units. maplibregl.Marker with
// anchor:'center' centers the whole element's bounding box on the LngLat,
// which is wrong for these icons — their point is not at the visual center.
var PIN_TIP_Y={heart:21.35,pin:22,house:20};
function makePinSVG(type){
  var paths={
    heart:'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',
    pin:'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
    house:'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'
  };
  var d=paths[type]||paths.heart;
  var tipY=PIN_TIP_Y[type]||PIN_TIP_Y.heart;
  var shiftPx=-((tipY-12)*(56/24)); // move icon up so its tip lands at the anchor point, not its box center
  var outer=document.createElement('div');
  outer.style.cssText='width:56px;height:56px;cursor:pointer;overflow:visible;';
  var inner=document.createElement('div');
  inner.style.cssText='width:56px;height:56px;transform:translateY('+shiftPx.toFixed(2)+'px);';
  inner.innerHTML='<svg viewBox="0 0 24 24" width="56" height="56" style="filter:drop-shadow(0 2px 3px rgba(0,0,0,0.35))"><path fill="#cc2200" d="'+d+'"/></svg>';
  outer.appendChild(inner);
  return outer;
}
function setPin(type){
  if(pinMarker){pinMarker.remove();pinMarker=null;}
  if(!mapCenter||!map) return;
  pinEl=makePinSVG(type);
  pinMarker=new maplibregl.Marker({element:pinEl,anchor:'center'})
    .setLngLat([mapCenter.lon,mapCenter.lat]).addTo(map);
}

// ── DETAIL TOGGLE ────────────────────────────────────────────────────────────
function setDetail(d){
  detail=d;
  if(!map||!map.isStyleLoaded()) return;
  var showMinor=(d==='med'||d==='high');
  var showService=(d==='high');
  try{
    map.setLayoutProperty('road-minor','visibility',showMinor?'visible':'none');
    map.setLayoutProperty('road-service','visibility',showService?'visible':'none');
  }catch(e){}
}

// ── EXTRACT FEATURES FROM VECTOR TILES ───────────────────────────────────────
var ROAD_LAYERS=['road-motorway','road-primary','road-secondary','road-minor','road-service'];
function extractFeatures(){
  if(!map) return{roads:[],water:[]};
  var visible=ROAD_LAYERS.filter(function(l){
    try{return map.getLayoutProperty(l,'visibility')!=='none';}catch(e){return true;}
  });
  var raw=map.queryRenderedFeatures({layers:visible.concat(['water'])});
  var roads=[],water=[];
  raw.forEach(function(f){
    if(f.layer.id==='water') water.push(f);
    else roads.push(f);
  });
  return{roads:roads,water:water};
}

// ── SVG EXPORT HELPERS ───────────────────────────────────────────────────────
function bezierPts(x0,y0,x1,y1,x2,y2,x3,y3,n){
  var p=[];for(var i=0;i<=n;i++){var t=i/n,m=1-t;p.push({x:m*m*m*x0+3*m*m*t*x1+3*m*t*t*x2+t*t*t*x3,y:m*m*m*y0+3*m*m*t*y1+3*m*t*t*y2+t*t*t*y3});}return p;
}
function quadPts(x0,y0,x1,y1,x2,y2,n){
  var p=[];for(var i=0;i<=n;i++){var t=i/n,m=1-t;p.push({x:m*m*x0+2*m*t*x1+t*t*x2,y:m*m*y0+2*m*t*y1+t*t*y2});}return p;
}
function otPathToClipper(otPath,CSCALE){
  var polys=[],cur=null,cx=0,cy=0;
  otPath.commands.forEach(function(cmd){
    if(cmd.type==='M'){if(cur&&cur.length>2)polys.push(cur);cur=[];cx=cmd.x;cy=cmd.y;cur.push({X:Math.round(cx*CSCALE),Y:Math.round(cy*CSCALE)});}
    else if(cmd.type==='L'){cx=cmd.x;cy=cmd.y;if(cur)cur.push({X:Math.round(cx*CSCALE),Y:Math.round(cy*CSCALE)});}
    else if(cmd.type==='C'){var pp=bezierPts(cx,cy,cmd.x1,cmd.y1,cmd.x2,cmd.y2,cmd.x,cmd.y,10);cx=cmd.x;cy=cmd.y;if(cur)for(var k=1;k<pp.length;k++)cur.push({X:Math.round(pp[k].x*CSCALE),Y:Math.round(pp[k].y*CSCALE)});}
    else if(cmd.type==='Q'){var pp=quadPts(cx,cy,cmd.x1,cmd.y1,cmd.x,cmd.y,8);cx=cmd.x;cy=cmd.y;if(cur)for(var k=1;k<pp.length;k++)cur.push({X:Math.round(pp[k].x*CSCALE),Y:Math.round(pp[k].y*CSCALE)});}
    else if(cmd.type==='Z'){if(cur&&cur.length>2)polys.push(cur);cur=null;}
  });
  if(cur&&cur.length>2)polys.push(cur);
  return polys;
}
function clipperUnionToD(paths,CSCALE){
  if(!paths||!paths.length) return '';
  var c=new ClipperLib.Clipper();
  c.AddPaths(paths,ClipperLib.PolyType.ptSubject,true);
  var u=new ClipperLib.Paths();
  c.Execute(ClipperLib.ClipType.ctUnion,u,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  return pathsToD(u,CSCALE);
}
function pathsToD(paths,CSCALE){
  return paths.map(function(poly){
    return 'M '+poly.map(function(pt){return (pt.X/CSCALE).toFixed(3)+' '+(pt.Y/CSCALE).toFixed(3);}).join(' L ')+' Z';
  }).join(' ');
}
function clipperUnionPaths(paths){
  if(!paths||!paths.length) return [];
  var c=new ClipperLib.Clipper();
  c.AddPaths(paths,ClipperLib.PolyType.ptSubject,true);
  var u=new ClipperLib.Paths();
  c.Execute(ClipperLib.ClipType.ctUnion,u,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  return u;
}
function clipperIntersect(subj,clip){
  if(!subj.length||!clip.length) return [];
  var c=new ClipperLib.Clipper();
  c.AddPaths(subj,ClipperLib.PolyType.ptSubject,true);
  c.AddPaths(clip,ClipperLib.PolyType.ptClip,true);
  var r=new ClipperLib.Paths();
  c.Execute(ClipperLib.ClipType.ctIntersection,r,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  return r;
}
function pointInPoly(pt,poly){
  var x=pt[1],y=pt[0],inside=false;
  for(var i=0,j=poly.length-1;i<poly.length;j=i++){
    var yi=poly[i][0],xi=poly[i][1],yj=poly[j][0],xj=poly[j][1];
    if((yi>y)!==(yj>y)&&x<(xj-xi)*(y-yi)/(yj-yi)+xi)inside=!inside;
  }
  return inside;
}
function circlePoly(cx,cy,r,n,CSCALE){
  var p=[];
  for(var i=0;i<n;i++){var a=2*Math.PI*i/n;p.push({X:Math.round((cx+r*Math.cos(a))*CSCALE),Y:Math.round((cy+r*Math.sin(a))*CSCALE)});}
  return p;
}

// ── CIRCLE CLIP HELPERS (for export) ─────────────────────────────────────────
function clipSeg(p1,p2,rMm){
  var dx=p2.x-p1.x,dy=p2.y-p1.y,a=dx*dx+dy*dy;
  if(a<1e-12)return null;
  var b=2*(p1.x*dx+p1.y*dy),c=p1.x*p1.x+p1.y*p1.y-rMm*rMm;
  var disc=b*b-4*a*c;if(disc<0)return null;
  var sq=Math.sqrt(disc),t0=Math.max(0,(-b-sq)/(2*a)),t1=Math.min(1,(-b+sq)/(2*a));
  if(t0>=t1-1e-9)return null;
  return{p1:{x:p1.x+t0*dx,y:p1.y+t0*dy},p2:{x:p1.x+t1*dx,y:p1.y+t1*dy}};
}
function clipPolyToCircle(pts,rMm){
  var out=[],cur=null,EPS=0.005;
  for(var i=0;i<pts.length-1;i++){
    var s=clipSeg(pts[i],pts[i+1],rMm);
    if(!s){if(cur){out.push(cur);cur=null;}continue;}
    if(cur&&Math.abs(cur[cur.length-1].x-s.p1.x)<EPS&&Math.abs(cur[cur.length-1].y-s.p1.y)<EPS)cur.push(s.p2);
    else{if(cur)out.push(cur);cur=[s.p1,s.p2];}
  }
  if(cur)out.push(cur);return out;
}
function clipChordAll(pts,chY){
  var out=[],cur=null;
  for(var i=0;i<pts.length-1;i++){
    var p1=pts[i],p2=pts[i+1];
    var in1=(p1.y<=chY),in2=(p2.y<=chY);
    if(in1&&in2){if(!cur)cur=[p1];cur.push(p2);}
    else if(in1&&!in2){
      var t=(chY-p1.y)/(p2.y-p1.y);
      if(!cur)cur=[p1];cur.push({x:p1.x+t*(p2.x-p1.x),y:chY});
      if(cur.length>1)out.push(cur);cur=null;
    }else if(!in1&&in2){
      var t=(chY-p1.y)/(p2.y-p1.y);
      cur=[{x:p1.x+t*(p2.x-p1.x),y:chY},p2];
    }else{if(cur&&cur.length>1)out.push(cur);cur=null;}
  }
  if(cur&&cur.length>1)out.push(cur);
  return out;
}

// ── GEOCODE HELPERS ──────────────────────────────────────────────────────────
function cleanGeoAddress(addr){
  // Keep FL (Florida), ZIP codes, route numbers and leading house numbers intact.
  // Only remove explicit secondary-unit designators, not the ambiguous "Fl".
  return addr.replace(/\r?\n+/g,', ')
    .replace(/\b(Suite|Ste|Apt|Apartment|Unit|Floor)\b\.?\s*#?\s*(?:[A-Za-z]?\d+[A-Za-z0-9-]*|[A-Za-z])\b/gi,'')
    .replace(/\b(Street|St|Avenue|Ave|Road|Rd|Boulevard|Blvd|Drive|Dr|Lane|Ln|Court|Ct|Place|Pl|Way|Circle|Cir|Terrace|Ter)\.?\s+#\s*[A-Za-z0-9-]+\b/gi,'$1')
    .replace(/\s*,\s*(?=,|$)/g,'').replace(/\s*,\s*/g,', ').replace(/\s{2,}/g,' ').trim();
}
function geoText(s){
  return String(s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/,/g,' ').replace(/\./g,'').replace(/\b(street|avenue|road|boulevard|drive|lane|court|place|highway|parkway|terrace|north|south|east|west|northeast|northwest|southeast|southwest)\b/g,function(s){
      return {street:'st',avenue:'ave',road:'rd',boulevard:'blvd',drive:'dr',lane:'ln',court:'ct',place:'pl',highway:'hwy',parkway:'pkwy',terrace:'ter',north:'n',south:'s',east:'e',west:'w',northeast:'ne',northwest:'nw',southeast:'se',southwest:'sw'}[s];
    }).replace(/\s+/g,' ').trim();
}
function geoHouseNumber(addr){
  var first=addr.split(',')[0].trim();
  var m=first.match(/^#?\s*(\d+[A-Za-z]?(?:\s*[-/]\s*\d+[A-Za-z]?)?)\s+(?=\S)/);
  // Also support street-first addresses such as "Baker Street 221B, London".
  if(!m&&addr.indexOf(',')!==-1&&/(?:\b(?:street|st|road|rd|rue|calle|avenue|ave|via|viale|platz|weg|strasse)\b|straße|straat)/i.test(first))m=first.match(/\s(\d+[A-Za-z]?)$/);
  return m?m[1].replace(/\s+/g,'').toLowerCase():'';
}
function validGeoPoint(coords){
  return Array.isArray(coords)&&coords.length>=2&&
    typeof coords[0]==='number'&&isFinite(coords[0])&&Math.abs(coords[0])<=180&&
    typeof coords[1]==='number'&&isFinite(coords[1])&&Math.abs(coords[1])<=90;
}
function isUSGeoAddress(addr){
  // The US-only fallback must not turn an unmatched overseas address into a US one.
  var states='AL|AK|AZ|AR|CA|CO|CT|DE|DC|FL|GA|HI|ID|IL|IN|IA|KS|KY|LA|ME|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VT|VA|WA|WV|WI|WY';
  var stateNames='Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|District of Columbia|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming';
  return /(?:^|,)\s*(?:United States(?: of America)?|USA|US|U\.S\.A?\.?)\s*$/i.test(addr)||
    new RegExp('\\b(?:'+states+'|'+stateNames+')\\s+\\d{5}(?:-\\d{4})?\\s*$','i').test(addr)||
    new RegExp(',\\s*(?:'+states+')\\.?\\s*$','i').test(addr);
}
function selectGeoFeature(features,addr,photon){
  var house=geoHouseNumber(addr),query=' '+geoText(addr)+' ';
  var usZip=addr.match(/\b(?:AL|AK|AZ|AR|CA|CO|CT|DE|DC|FL|GA|HI|ID|IL|IN|IA|KS|KY|LA|ME|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VT|VA|WA|WV|WI|WY)\s+(\d{5})(?:-\d{4})?\b/i);
  var matches=(Array.isArray(features)?features:[]).filter(function(f){
    if(!f||!f.geometry||f.geometry.type!=='Point'||!validGeoPoint(f.geometry.coordinates))return false;
    var p=f.properties||{},a=photon?p:(p.address||{});
    if(usZip&&((a.country_code||a.countrycode||'').toLowerCase()!=='us'||String(a.postcode||'').slice(0,5)!==usZip[1]))return false;
    if(!house)return true;
    // Never substitute a street/city centroid or a nearby house for a numbered address.
    var actualHouse=String(a.house_number||a.housenumber||'').replace(/\s+/g,'').toLowerCase();
    // Some exact named POIs (e.g. 221B Baker Street) omit the separate house field.
    var namedHouse=!actualHouse&&(photon?p.type==='house':p.place_rank>=28)&&geoText(p.name)===geoText(addr.split(',')[0]);
    if(actualHouse!==house&&!namedHouse)return false;
    var street=a.road||a.street||a.pedestrian||a.residential||a.footway||a.path;
    return !!street&&query.indexOf(' '+geoText(street)+' ')!==-1;
  });
  // Multiple distant houses with the same address need a more specific query.
  if(house&&matches.length>1){
    var c=matches[0].geometry.coordinates;
    if(matches.some(function(f){var p=f.geometry.coordinates;return Math.abs(p[1]-c[1])>0.01||Math.abs(p[0]-c[0])*Math.cos(c[1]*Math.PI/180)>0.01;}))return null;
  }
  return matches[0]||null;
}
function applyGeoResult(cLat,cLon,label){
  mapCenter={lat:cLat,lon:cLon};
  mapLabel=label;
  map.resize();
  map.jumpTo({center:[cLon,cLat],zoom:zoom});
  var pinType=(document.querySelector('.pin-btn.on')||{dataset:{pin:'heart'}}).dataset.pin;
  setPin(pinType);
  document.getElementById('noMapPlaceholder').style.display='none';
  mapLoaded=true;
  var dlBtn=document.getElementById('downloadBtn');if(dlBtn)dlBtn.disabled=false;
  setStatus('ok','\u2713 '+mapLabel+' \u2014 loading map tiles\u2026');
  setDetail(detail);
  var requestId=geoRequestId;
  map.once('idle',function(){ if(mapLoaded&&requestId===geoRequestId)setStatus('ok','\u2713 '+mapLabel); });
}

// ── GEOCODE & LOAD MAP ───────────────────────────────────────────────────────
async function loadMap(){
  var addr=document.getElementById('addressInput').value.trim();
  if(!addr||isLoading) return;
  var requestId=++geoRequestId;
  mapLoaded=false;
  var dlBtn=document.getElementById('downloadBtn');if(dlBtn)dlBtn.disabled=true;
  isLoading=true;
  var btn=document.getElementById('fetchBtn');
  btn.disabled=true;btn.textContent='Loading\u2026';
  setStatus('','Geocoding\u2026');
  try{
    var cleanAddr=cleanGeoAddress(addr);

    // ── Try Nominatim first ──
    var cLat=null,cLon=null,label='';
    try{
      var res=await fetch('https://nominatim.openstreetmap.org/search?format=geojson&addressdetails=1&limit=5&q='+encodeURIComponent(cleanAddr),{headers:{'Accept-Language':'en'}});
      if(res.ok){
        var data=await res.json();
        var feature=selectGeoFeature(data.features,cleanAddr,false);
        if(feature){
          cLon=feature.geometry.coordinates[0];
          cLat=feature.geometry.coordinates[1];
          label=((feature.properties||{}).display_name||addr).split(',').slice(0,2).join(',');
        }
      }
    }catch(e){}

    // ── Fallback 1: Photon geocoder (OSM-based) ──
    if(requestId!==geoRequestId)return;
    if(cLat===null){
      setStatus('','Trying alternate geocoder\u2026');
      try{
        var pRes=await fetch('https://photon.komoot.io/api/?q='+encodeURIComponent(cleanAddr)+'&limit=5');
        if(pRes.ok){
          var pData=await pRes.json();
          var pFeature=selectGeoFeature(pData.features,cleanAddr,true);
          if(pFeature){
            cLon=pFeature.geometry.coordinates[0];
            cLat=pFeature.geometry.coordinates[1];
            var pp=pFeature.properties||{};
            label=[pp.name||pp.street||'',pp.city||pp.county||''].filter(Boolean).join(', ')||addr.split(',').slice(0,2).join(',');
          }
        }
      }catch(e){}
    }

    // ── Fallback 2: US Census Bureau geocoder via JSONP (no CORS support on this API) ──
    if(requestId!==geoRequestId)return;
    if(cLat===null&&isUSGeoAddress(cleanAddr)){
      setStatus('','Trying US address lookup\u2026');
      try{
        var censusResult=await new Promise(function(resolve){
          var cbName='_censusGeo'+Date.now();
          var timeout=setTimeout(function(){delete window[cbName];resolve(null);},6000);
          window[cbName]=function(data){
            clearTimeout(timeout);delete window[cbName];resolve(data);
          };
          var sc=document.createElement('script');
          sc.src='https://geocoding.geo.census.gov/geocoder/locations/onelineaddress?address='+encodeURIComponent(cleanAddr)+'&benchmark=Public_AR_Current&format=jsonp&callback='+cbName;
          sc.onerror=function(){clearTimeout(timeout);delete window[cbName];resolve(null);};
          document.head.appendChild(sc);
          sc.onload=function(){document.head.removeChild(sc);};
        });
        if(censusResult&&censusResult.result&&censusResult.result.addressMatches&&censusResult.result.addressMatches.length){
          var censusFeatures=censusResult.result.addressMatches.map(function(m){
            var a=m.addressComponents||{},street=(m.matchedAddress||'').split(',')[0];
            return {geometry:{type:'Point',coordinates:m.coordinates?[m.coordinates.x,m.coordinates.y]:[]},properties:{
              housenumber:geoHouseNumber(m.matchedAddress||''),
              street:street.replace(/^\s*\d+[A-Za-z]?(?:\s*[-/]\s*\d+[A-Za-z]?)?\s+/,''),
              postcode:a.zip,countrycode:'US',display_name:m.matchedAddress
            }};
          });
          var censusFeature=selectGeoFeature(censusFeatures,cleanAddr,true);
          if(censusFeature){
            cLon=censusFeature.geometry.coordinates[0];
            cLat=censusFeature.geometry.coordinates[1];
            label=(censusFeature.properties.display_name||addr.split(',').slice(0,2).join(','))+' (approximate street position)';
          }
        }
      }catch(e){}
    }

    if(requestId!==geoRequestId)return;
    if(cLat!==null){
      applyGeoResult(cLat,cLon,label);
    }else{
      setStatus('err','Address could not be matched precisely \u2014 check the house number and include the city, state/postcode and country.');
    }
  }catch(err){
    setStatus('err','Error: '+err.message);
  }finally{
    isLoading=false;btn.disabled=false;btn.textContent='Search & Load Map';
  }
}

// ── SVG EXPORT ───────────────────────────────────────────────────────────────
async function exportSVG(){
  if(!map||!mapLoaded){alert('Load a map first.');return;}
  var btn=document.getElementById('downloadBtn');
  btn.disabled=true;btn.textContent='Preparing\u2026';
  try{
    var CSCALE=1e4;
    var unit=getUnit(),realDiam=(unit==='in')?(size*25.4):size;
    var rMm=realDiam/2;
    var mapEl=document.getElementById('mapContainer');
    var mapR=(mapEl&&mapEl.offsetWidth>0)?mapEl.offsetWidth/2:285;
    var sc=rMm/mapR;
    var ctrPx=map.project(map.getCenter());
    function ll2mm(la,lo){var p=map.project([lo,la]);return{x:(p.x-ctrPx.x)*sc,y:(p.y-ctrPx.y)*sc};}

    var chY=rMm*(61/150),chDx=rMm*(137/150);
    var ringIn=rMm*(133/150);
    var hoopY=-(172/150)*rMm;
    var hoopO=rMm*(19/150),hoopI=rMm*(11/150);
    var GAP=8;

    // ── EXTRACT FEATURES ──────────────────────────────────────────────────
    btn.textContent='Extracting map data\u2026';
    var feats=extractFeatures();

    // ── ROADS ─────────────────────────────────────────────────────────────
    btn.textContent='Outlining roads\u2026';
    var WEIGHTS={motorway:7,trunk:5.5,primary:4.5,secondary:3,tertiary:2,
                 residential:1.4,unclassified:1.4,living_street:1.1,
                 service:0.8,pedestrian:0.8,busway:0.8,minor:1.4,track:0.6,path:0.5};
    var allRoadPaths=new ClipperLib.Paths();
    feats.roads.forEach(function(feat){
      var cls=feat.properties.class||'';
      var hw=(WEIGHTS[cls]||1)*sc/2;
      var geom=feat.geometry;
      if(!geom) return;
      var lines=geom.type==='MultiLineString'?geom.coordinates:[geom.coordinates];
      lines.forEach(function(coords){
        if(!coords||coords.length<2) return;
        var mmPts=coords.map(function(c){return ll2mm(c[1],c[0]);});
        clipPolyToCircle(mmPts,rMm).forEach(function(seg){
          clipChordAll(seg,chY).forEach(function(upperSeg){
            if(upperSeg.length<2) return;
            var cPath=upperSeg.map(function(pt){return{X:Math.round(pt.x*CSCALE),Y:Math.round(pt.y*CSCALE)};});
            var co=new ClipperLib.ClipperOffset();co.ArcTolerance=0.12*CSCALE;
            co.AddPath(cPath,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etOpenRound);
            var off=new ClipperLib.Paths();co.Execute(off,hw*CSCALE);
            for(var i=0;i<off.length;i++)allRoadPaths.push(off[i]);
          });
        });
      });
    });
    btn.textContent='Merging roads\u2026';
    var allRoadD=clipperUnionToD(allRoadPaths,CSCALE);

    // ── WATER ─────────────────────────────────────────────────────────────
    btn.textContent='Processing water\u2026';
    var waterRawPaths=new ClipperLib.Paths();
    var circClip=[circlePoly(0,0,rMm,128,CSCALE)];
    feats.water.forEach(function(feat){
      var geom=feat.geometry;if(!geom) return;
      var polys=geom.type==='MultiPolygon'?geom.coordinates:(geom.type==='Polygon'?[geom.coordinates]:[]);
      polys.forEach(function(rings){
        if(!rings.length||rings[0].length<4) return;
        // Outer ring (water area) — intersect with circle
        var outerMm=rings[0].map(function(c){return ll2mm(c[1],c[0]);});
        var outerCPoly=[outerMm.map(function(pt){return{X:Math.round(pt.x*CSCALE),Y:Math.round(pt.y*CSCALE)};})];
        var outerClipped=clipperIntersect(outerCPoly,circClip);
        if(!outerClipped.length) return;
        // Inner rings (holes = islands within water) — subtract from outer
        if(rings.length>1){
          var holePaths=new ClipperLib.Paths();
          for(var ri=1;ri<rings.length;ri++){
            if(rings[ri].length<4) continue;
            var holeMm=rings[ri].map(function(c){return ll2mm(c[1],c[0]);});
            var holeCPoly=[holeMm.map(function(pt){return{X:Math.round(pt.x*CSCALE),Y:Math.round(pt.y*CSCALE)};})];
            var holeClipped=clipperIntersect(holeCPoly,circClip);
            for(var h=0;h<holeClipped.length;h++) holePaths.push(holeClipped[h]);
          }
          if(holePaths.length){
            var cDiff=new ClipperLib.Clipper();
            cDiff.AddPaths(outerClipped,ClipperLib.PolyType.ptSubject,true);
            cDiff.AddPaths(holePaths,ClipperLib.PolyType.ptClip,true);
            var diffRes=new ClipperLib.Paths();
            cDiff.Execute(ClipperLib.ClipType.ctDifference,diffRes,
              ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
            for(var i=0;i<diffRes.length;i++) waterRawPaths.push(diffRes[i]);
          }else{
            for(var i=0;i<outerClipped.length;i++) waterRawPaths.push(outerClipped[i]);
          }
        }else{
          for(var i=0;i<outerClipped.length;i++) waterRawPaths.push(outerClipped[i]);
        }
      });
    });
    var waterFinal=clipperUnionPaths(waterRawPaths);
    var waterD=pathsToD(waterFinal,CSCALE);

    // ── TEXT ───────────────────────────────────────────────────────────────
    btn.textContent='Loading fonts\u2026';
    var l1t=(document.getElementById('line1').value||'Where We Became a Family').toUpperCase();
    var l2t=document.getElementById('line2').value||"The Bassetts'";
    var l3t=document.getElementById('line3').value||'2002\u20132025';
    var sp12v=parseInt((document.getElementById('sp12')||{value:0}).value)||0;
    var sp23v=parseInt((document.getElementById('sp23')||{value:0}).value)||0;
    var fs1=arcSz[1]*rMm/150,fs2=arcSz[2]*rMm/150,fs3=arcSz[3]*rMm/150;
    var ty1=76*rMm/150,ty2=ty1+(25+sp12v)*rMm/150,ty3=ty2+(22+sp23v)*rMm/150;
    var ls1=0.27,ls3=0.22;
    var l2fDropdown=(document.getElementById('line2Font')||{value:'Dancing Script'}).value;
    var FURL2={
      'Dancing Script':'https://cdn.jsdelivr.net/npm/@fontsource/dancing-script/files/dancing-script-latin-700-normal.woff',
      'Great Vibes':'https://cdn.jsdelivr.net/npm/@fontsource/great-vibes/files/great-vibes-latin-400-normal.woff',
      'Parisienne':'https://cdn.jsdelivr.net/npm/@fontsource/parisienne/files/parisienne-latin-400-normal.woff',
      'Sacramento':'https://cdn.jsdelivr.net/npm/@fontsource/sacramento/files/sacramento-latin-400-normal.woff',
      'Pinyon Script':'https://cdn.jsdelivr.net/npm/@fontsource/pinyon-script/files/pinyon-script-latin-400-normal.woff',
      'Cormorant Garamond':'https://cdn.jsdelivr.net/npm/@fontsource/cormorant-garamond/files/cormorant-garamond-latin-600-normal.woff',
      'Cinzel':'https://cdn.jsdelivr.net/npm/@fontsource/cinzel/files/cinzel-latin-600-normal.woff',
      'Alex Brush':'https://cdn.jsdelivr.net/npm/@fontsource/alex-brush/files/alex-brush-latin-400-normal.woff'
    };
    var f1url='https://cdn.jsdelivr.net/npm/@fontsource/cinzel/files/cinzel-latin-600-normal.woff';
    var f2url=FURL2[l2fDropdown]||FURL2['Dancing Script'];

    function t2pClipper(font,text,cx,cy,sz,ls){
      if(!font||!text.trim()) return '';
      try{
        var opts={letterSpacing:ls||0};
        var pp=font.getPaths(text,0,cy,sz,opts);
        var bx1=Infinity,bx2=-Infinity;
        pp.forEach(function(p){try{var b=p.getBoundingBox();if(isFinite(b.x1)){bx1=Math.min(bx1,b.x1);bx2=Math.max(bx2,b.x2);}}catch(e){}});
        if(!isFinite(bx1)||bx1>=bx2){bx1=0;bx2=font.getAdvanceWidth(text,sz,opts);}
        var startX=cx-(bx1+bx2)/2;
        var otPath=font.getPath(text,startX,cy,sz,opts);
        var polys=otPathToClipper(otPath,CSCALE);
        if(!polys.length) return '';
        return clipperUnionToD(polys,CSCALE);
      }catch(e){console.warn('t2p error:',e);return '';}
    }

    var tp1='',tp2='',tp3='',textAsPath=false;
    if(typeof opentype!=='undefined'){
      var FC={};
      async function lF(u){if(FC[u])return FC[u];var ab=await fetch(u).then(function(r){return r.arrayBuffer();});return(FC[u]=opentype.parse(ab));}
      try{
        btn.textContent='Loading fonts (1/3)\u2026';var font1=await lF(f1url);
        btn.textContent='Loading fonts (2/3)\u2026';var font2=await lF(f2url);
        btn.textContent='Loading fonts (3/3)\u2026';var font3=font1;
        btn.textContent='Merging text glyphs\u2026';
        tp1=t2pClipper(font1,l1t,0,ty1,fs1,ls1);
        tp2=t2pClipper(font2,l2t,0,ty2,fs2,0);
        tp3=t2pClipper(font3,l3t,0,ty3,fs3,ls3);
        textAsPath=!!(tp1||tp2||tp3);
      }catch(fe){console.warn('Font error:',fe);}
    }

    // ── HEART PIN ─────────────────────────────────────────────────────────
    var pinPt=mapCenter?ll2mm(mapCenter.lat,mapCenter.lon):{x:0,y:0};
    var pinInCircle=Math.sqrt(pinPt.x*pinPt.x+pinPt.y*pinPt.y)<rMm*0.98;
    var pinVisible=pinInCircle&&pinPt.y<chY;
    var PIN_PATHS={
      heart:'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',
      pin:'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
      house:'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'
    };
    var activePinType=(document.querySelector('.pin-btn.on')||{dataset:{pin:'heart'}}).dataset.pin;
    var heartD=PIN_PATHS[activePinType]||PIN_PATHS.heart;
    var pinSizeMm=rMm*0.13,pinSc=pinSizeMm/20;

    // ── HOOP & CUT GEOMETRY ───────────────────────────────────────────────
    var exportHoopY=hoopY+hoopO*0.35;
    var mainCircPoly=[circlePoly(0,0,rMm,128,CSCALE)];
    var hoopOuterPoly=[circlePoly(0,exportHoopY,hoopO,48,CSCALE)];
    var hoopInnerPoly=[circlePoly(0,exportHoopY,hoopI,36,CSCALE)];
    var cH=new ClipperLib.Clipper();
    cH.AddPaths(hoopOuterPoly,ClipperLib.PolyType.ptSubject,true);
    cH.AddPaths(hoopInnerPoly,ClipperLib.PolyType.ptClip,true);
    var hoopRing=new ClipperLib.Paths();
    cH.Execute(ClipperLib.ClipType.ctDifference,hoopRing,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
    var cL=new ClipperLib.Clipper();
    cL.AddPaths(mainCircPoly,ClipperLib.PolyType.ptSubject,true);
    cL.AddPaths(hoopRing,ClipperLib.PolyType.ptClip,true);
    var l1CutPaths=new ClipperLib.Paths();
    cL.Execute(ClipperLib.ClipType.ctUnion,l1CutPaths,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
    var l1CutD=pathsToD(l1CutPaths,CSCALE);

    // ── LAYER 2 (ring + arc text piece) ───────────────────────────────────
    var R=rMm,Ri=ringIn;
    var arcChDx=Math.sqrt(Math.max(0,Ri*Ri-chY*chY));
    var mergedD='M '+R.toFixed(3)+' 0 A '+R.toFixed(3)+' '+R.toFixed(3)+' 0 1 0 '+(-R).toFixed(3)+' 0 A '+R.toFixed(3)+' '+R.toFixed(3)+' 0 1 0 '+R.toFixed(3)+' 0 Z'+
      ' M '+arcChDx.toFixed(3)+' '+chY.toFixed(3)+' A '+Ri.toFixed(3)+' '+Ri.toFixed(3)+' 0 1 0 '+(-arcChDx).toFixed(3)+' '+chY.toFixed(3)+' L '+arcChDx.toFixed(3)+' '+chY.toFixed(3)+' Z';

    // ── 3-LAYER MODE: compute land shape (circle minus water) ─────────────
    var l3tog=document.getElementById('layer3Toggle');
    var is3Layer=l3tog&&l3tog.checked;
    var landCutD='';
    if(is3Layer&&waterFinal.length){
      var cL3=new ClipperLib.Clipper();
      cL3.AddPaths(mainCircPoly,ClipperLib.PolyType.ptSubject,true);
      cL3.AddPaths(waterFinal,ClipperLib.PolyType.ptClip,true);
      var landPaths=new ClipperLib.Paths();
      cL3.Execute(ClipperLib.ClipType.ctDifference,landPaths,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
      var innerCircPoly=[circlePoly(0,0,ringIn,128,CSCALE)];
      var cRing=new ClipperLib.Clipper();
      cRing.AddPaths(mainCircPoly,ClipperLib.PolyType.ptSubject,true);
      cRing.AddPaths(innerCircPoly,ClipperLib.PolyType.ptClip,true);
      var ringPaths=new ClipperLib.Paths();
      cRing.Execute(ClipperLib.ClipType.ctDifference,ringPaths,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
      var cUnion=new ClipperLib.Clipper();
      cUnion.AddPaths(landPaths,ClipperLib.PolyType.ptSubject,true);
      cUnion.AddPaths(ringPaths,ClipperLib.PolyType.ptClip,true);
      var landWithRing=new ClipperLib.Paths();
      cUnion.Execute(ClipperLib.ClipType.ctUnion,landWithRing,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
      landCutD=pathsToD(landWithRing,CSCALE);
    }else if(is3Layer){
      landCutD=pathsToD([circlePoly(0,0,rMm,128,CSCALE)],CSCALE);
    }

    // ── BUILD SVG ─────────────────────────────────────────────────────────
    btn.textContent='Building SVG\u2026';
    var p2x=2*rMm+GAP;
    var frameX=is3Layer?(4*rMm+2*GAP):p2x;
    var vbL=-(rMm+4),vbT=exportHoopY-hoopO-4,vbR=(is3Layer?frameX:p2x)+rMm+4,vbB=rMm+28;
    var vbW=vbR-vbL,vbH=vbB-vbT;
    var P=[];
    P.push('<?xml version="1.0" encoding="UTF-8"?>');
    P.push('<!-- Map Ornament | #000000=engrave | #ff0000=cut | #7ec8e3=light engrave (water) -->');
    P.push('<svg xmlns="http://www.w3.org/2000/svg" width="'+vbW.toFixed(2)+'mm" height="'+vbH.toFixed(2)+'mm" viewBox="'+vbL.toFixed(2)+' '+vbT.toFixed(2)+' '+vbW.toFixed(2)+' '+vbH.toFixed(2)+'">');

    if(is3Layer){
      P.push('<g id="L1-water">');
      P.push('  <text x="0" y="'+(rMm+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(rMm*0.045).toFixed(2)+'" fill="#888888">Layer 1 (Water): <tspan fill="#ff0000">Red=CUT</tspan></text>');
      if(l1CutD) P.push('  <path id="L1-cut" d="'+l1CutD+'" fill="none" stroke="#ff0000" stroke-width="0.5" fill-rule="evenodd"/>');
      P.push('</g>');
      if(pinVisible){
        var gapX=rMm+GAP/2;
        var gapY=-(rMm*0.65);
        P.push('<g id="heart-pin" transform="translate('+gapX.toFixed(3)+','+gapY.toFixed(3)+') scale('+pinSc.toFixed(4)+') translate(-12,-12)">');
        P.push('  <path d="'+heartD+'" fill="none" stroke="#ff0000" stroke-width="0.5"/>');
        P.push('</g>');
      }
      P.push('<g id="L2-land" transform="translate('+p2x.toFixed(2)+',0)">');
      P.push('  <text x="0" y="'+(rMm+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(rMm*0.045).toFixed(2)+'" fill="#888888">Layer 2 (Land): <tspan fill="#ff0000">Red=CUT</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#000000">Black=Engrave</tspan></text>');
      if(allRoadD.trim()) P.push('  <path id="roads" fill="#000000" fill-rule="evenodd" stroke="none" d="'+allRoadD.trim()+'"/>');
      if(landCutD) P.push('  <path id="L2-land-cut" d="'+landCutD+'" fill="none" stroke="#ff0000" stroke-width="0.5" fill-rule="evenodd"/>');
      P.push('</g>');
    }else{
      P.push('<g id="L1">');
      P.push('  <text x="0" y="'+(rMm+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(rMm*0.045).toFixed(2)+'" fill="#888888">Layer 1: <tspan fill="#ff0000">Red=CUT</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#000000">Black=Engrave</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#4a9fc4">Blue=Light engrave (water)</tspan></text>');
      if(allRoadD.trim()) P.push('  <path id="roads" fill="#000000" fill-rule="evenodd" stroke="none" d="'+allRoadD.trim()+'"/>');
      if(waterD.trim()) P.push('  <path id="water" fill="#7ec8e3" fill-rule="evenodd" stroke="none" d="'+waterD.trim()+'"/>');
      if(l1CutD) P.push('  <path id="L1-cut" d="'+l1CutD+'" fill="none" stroke="#ff0000" stroke-width="0.5" fill-rule="evenodd"/>');
      P.push('</g>');
      if(pinVisible){
        var gapX=rMm+GAP/2;
        var gapY=-(rMm*0.65);
        P.push('<g id="heart-pin" transform="translate('+gapX.toFixed(3)+','+gapY.toFixed(3)+') scale('+pinSc.toFixed(4)+') translate(-12,-12)">');
        P.push('  <path d="'+heartD+'" fill="none" stroke="#ff0000" stroke-width="0.5"/>');
        P.push('</g>');
      }
    }
    { // Frame (ring+arc) — always included
      P.push('<g id="'+(is3Layer?'L3':'L2')+'" transform="translate('+(is3Layer?frameX:p2x).toFixed(2)+',0)">');
      P.push('  <text x="0" y="'+(rMm+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(rMm*0.045).toFixed(2)+'" fill="#888888">'+(is3Layer?'Layer 3':'Layer 2')+': <tspan fill="#ff0000">Red=CUT</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#000000">Black=Engrave</tspan></text>');
      P.push('  <path id="frame-cut" d="'+mergedD+'" fill="none" stroke="#ff0000" stroke-width="0.5" fill-rule="evenodd"/>');
      if(textAsPath){
        if(tp1) P.push('  <path id="text1" d="'+tp1+'" fill="#000000" fill-rule="evenodd"/>');
        if(tp2) P.push('  <path id="text2" d="'+tp2+'" fill="#000000" fill-rule="evenodd"/>');
        if(tp3) P.push('  <path id="text3" d="'+tp3+'" fill="#000000" fill-rule="evenodd"/>');
      }else{
        P.push('  <!-- Fonts unavailable \u2013 convert text to outlines in Illustrator -->');
        P.push('  <text x="0" y="'+ty1.toFixed(2)+'" text-anchor="middle" font-family="Cinzel,serif" font-size="'+fs1.toFixed(3)+'mm">'+xmlEsc(l1t)+'</text>');
        P.push('  <text x="0" y="'+ty2.toFixed(2)+'" text-anchor="middle" font-family="'+xmlEsc(l2fDropdown)+',cursive" font-size="'+fs2.toFixed(3)+'mm">'+xmlEsc(l2t)+'</text>');
        P.push('  <text x="0" y="'+ty3.toFixed(2)+'" text-anchor="middle" font-family="Cinzel,serif" font-size="'+fs3.toFixed(3)+'mm">'+xmlEsc(l3t)+'</text>');
      }
      P.push('</g>');
    }
    P.push('</svg>');

    var svg=P.join('\n');
    var blob=new Blob([svg],{type:'image/svg+xml'});
    var url=URL.createObjectURL(blob);
    var a=document.createElement('a');a.href=url;a.download='map-ornament.svg';a.click();
    setTimeout(function(){URL.revokeObjectURL(url);},1000);
    setStatus('ok','\u2713 SVG exported');
  }catch(err){
    console.error('Export error:',err);
    setStatus('err','Export error: '+err.message);
  }finally{
    btn.disabled=false;btn.textContent='\u2193 Download SVG';
  }
}

// ── CONTROLS ─────────────────────────────────────────────────────────────────
document.getElementById('zoomSlider').addEventListener('input',function(){
  zoom=parseFloat(this.value);
  zoomValEl.textContent=fmtZoom(zoom);
  if(map) map.setZoom(zoom);
});
document.getElementById('sizeDown').onclick=function(){
  var el=document.getElementById('sizeVal'),u=getUnit(),step=u==='in'?0.5:5;
  size=Math.max(sizeMin,+(((parseFloat(el.value||el.textContent)||4)-step).toFixed(3)));
  if(el.tagName==='INPUT')el.value=size;else el.textContent=size;updateDimHint();
};
document.getElementById('sizeUp').onclick=function(){
  var el=document.getElementById('sizeVal'),u=getUnit(),step=u==='in'?0.5:5;
  size=Math.min(sizeMax,+(((parseFloat(el.value||el.textContent)||4)+step).toFixed(3)));
  if(el.tagName==='INPUT')el.value=size;else el.textContent=size;updateDimHint();
};
document.querySelectorAll('.seg .sb').forEach(function(btn){
  btn.addEventListener('click',function(){
    var g=btn.dataset.group;if(!g)return;
    document.querySelectorAll('.sb[data-group="'+g+'"]').forEach(function(b){b.classList.remove('on');});
    btn.classList.add('on');
    if(g==='detail') setDetail(btn.dataset.val);
  });
});
document.querySelectorAll('[data-group="unit"]').forEach(function(btn){
  btn.addEventListener('click',function(){
    var prevUnit=getUnit();
    document.querySelectorAll('[data-group="unit"]').forEach(function(b){b.classList.remove('on');});
    btn.classList.add('on');
    var nextUnit=getUnit();
    if(prevUnit===nextUnit)return;
    var el=document.getElementById('sizeVal');
    var v=parseFloat(el?(el.value||el.textContent):'4')||4;
    if(prevUnit==='in'&&nextUnit==='mm')v=Math.round(v*25.4*10)/10;
    else if(prevUnit==='mm'&&nextUnit==='in')v=Math.round(v/25.4*100)/100;
    size=v;sizeMin=nextUnit==='in'?1:25;sizeMax=nextUnit==='in'?12:300;
    if(el){if(el.tagName==='INPUT')el.value=v;else el.textContent=v;}
    updateDimHint();
  });
});
document.querySelectorAll('.pin-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    document.querySelectorAll('.pin-btn').forEach(function(b){b.classList.remove('on');});
    btn.classList.add('on');
    if(mapCenter) setPin(btn.dataset.pin);
  });
});
document.getElementById('fetchBtn').addEventListener('click',loadMap);
document.getElementById('addressInput').addEventListener('keydown',function(e){if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();loadMap();}});

var SZ_MIN=[0,5,10,5],SZ_MAX=[0,18,60,20],SZ_STEP=[0,0.5,1,0.5];
document.querySelectorAll('.arc-sz-btn').forEach(function(b){
  b.addEventListener('click',function(){
    var line=parseInt(this.dataset.szline),dir=parseInt(this.dataset.dir);
    arcSz[line]=Math.max(SZ_MIN[line],Math.min(SZ_MAX[line],arcSz[line]+SZ_STEP[line]*dir));
    var valEl=document.getElementById('sz'+line+'val');
    if(valEl)valEl.textContent=arcSz[line].toFixed(arcSz[line]%1?1:0);
    updatePreview();
  });
});
var l2f=document.getElementById('line2Font');
if(l2f)l2f.addEventListener('change',updatePreview);
['sp12','sp23'].forEach(function(id){var el=document.getElementById(id);if(el)el.addEventListener('input',updatePreview);});
var dlBtnEl=document.getElementById('downloadBtn');if(dlBtnEl)dlBtnEl.addEventListener('click',exportSVG);

// ── PREVIEW ──────────────────────────────────────────────────────────────────
function updatePreview(){
  var l1=document.getElementById('line1').value||'Where We Became a Family';
  var l2=document.getElementById('line2').value||"The Bassetts'";
  var l3=document.getElementById('line3').value||'2002\u20132025';
  var f2sel=document.getElementById('line2Font');
  var f2font=f2sel?f2sel.value:'Dancing Script';
  var fs1=arcSz[1],fs2=arcSz[2],fs3=arcSz[3];
  var sp12=parseInt((document.getElementById('sp12')||{value:0}).value)||0;
  var sp23=parseInt((document.getElementById('sp23')||{value:0}).value)||0;
  var ty1=276,ty2=301+sp12,ty3=323+sp12+sp23;
  function set(id,txt,font,fs,ty,ls){
    var e=document.getElementById(id);if(!e)return;
    e.textContent=txt;
    if(font)e.setAttribute('font-family',font);
    if(fs)e.setAttribute('font-size',fs);
    if(ty)e.setAttribute('y',ty);
    if(ls!=null)e.setAttribute('letter-spacing',ls);
  }
  set('prevLine1',l1.toUpperCase(),'Cinzel,serif',fs1,ty1,(fs1*0.2).toFixed(1));
  set('prevLine2',l2,f2font+',cursive',fs2,ty2,0);
  set('prevLine3',l3,'Cinzel,serif',fs3,ty3,(fs3*0.2).toFixed(1));
}
['line1','line2','line3'].forEach(function(id){var e=document.getElementById(id);if(e)e.addEventListener('input',updatePreview);});

// ── RESET ────────────────────────────────────────────────────────────────────
document.getElementById('resetBtn').addEventListener('click',function(){
  geoRequestId++;
  document.getElementById('addressInput').value='';
  setStatus('','No map loaded');
  ['line1','line2','line3'].forEach(function(id){document.getElementById(id).value='';});
  zoom=14;zoomValEl.textContent='14';document.getElementById('zoomSlider').value='14';
  size=4;updateDimHint();detail='med';
  document.querySelectorAll('.pin-btn').forEach(function(b,i){b.classList.toggle('on',i===0);});
  document.querySelectorAll('.sb[data-group="detail"]').forEach(function(b){b.classList.toggle('on',b.dataset.val==='med');});
  var l3t=document.getElementById('layer3Toggle');if(l3t)l3t.checked=false;
  if(pinMarker){pinMarker.remove();pinMarker=null;}
  if(map) map.jumpTo({center:[0,20],zoom:2});
  mapCenter=null;mapLoaded=false;
  document.getElementById('noMapPlaceholder').style.display='';
  var dlBtnR=document.getElementById('downloadBtn');if(dlBtnR)dlBtnR.disabled=true;
  arcSz=[0,8,24,8.5];
  ['sz1val','sz2val','sz3val'].forEach(function(id,i){var e=document.getElementById(id);if(e)e.textContent=arcSz[i+1];});
  var sp12e=document.getElementById('sp12');if(sp12e)sp12e.value=0;
  var sp23e=document.getElementById('sp23');if(sp23e)sp23e.value=0;
  updatePreview();
});

// ── INIT ─────────────────────────────────────────────────────────────────────
window._appLoadMap=loadMap;
window.onerror=function(msg,src,line,col,err){
  var el=document.getElementById('mapStatus');
  if(el)el.innerHTML='<span style="color:#ff7c7c;font-weight:700">JS Error: '+msg+' (line '+line+')</span>';
  return false;
};
try{initMap();}catch(e){
  var el=document.getElementById('mapStatus');
  if(el)el.innerHTML='<span style="color:#ff7c7c;font-weight:700">Map init error: '+e.message+'</span>';
}
updateDimHint();
updatePreview();

})();

// ── Analytics tracking ───────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  var loadMapBtn = document.querySelector('.mapornament_load_map');
  var addressInput = document.getElementById('addressInput');

  if (loadMapBtn) {
    loadMapBtn.addEventListener('click', function () {
      var address = addressInput.value.trim();
      if (address !== '') {
        gtag('event', 'mapornament_load_map', {
          event_category: 'generator',
          generator_type: 'mapornament',
          event_label: 'load_map_button_clicked',
          address: address
        });
      }
    });
  }

  var downloadBtn = document.querySelector('.mapornament_download_svg');
  if (downloadBtn) {
    downloadBtn.addEventListener('click', function () {
      gtag('event', 'mapornament_download_svg', {
        event_category: 'generator',
        generator_type: 'mapornament',
        event_label: 'download_svg_button_clicked',
        address: addressInput.value.trim()
      });
    });
  }
});
